import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  useMediaQuery,
} from '@mui/material';
import React from 'react';
import Text from './Text';
import theme from '../../theme';
import { ProjectCard } from '@manobin/ireno-generated-api';

interface Props {
  label: string;
  type: string;
  items: Array<ProjectCard>;
}
import AppModal from './AppModal';

const List: React.FC<Props> = ({ label, items, type }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <section>
      <Text
        mv={3}
        color="black"
        size="big"
        variant={'h2'}
      >{`${type} Projects for ${label}`}</Text>

      <Grid
        onClick={() => {
          if (isMobile) {
            window.location.href = 'https://renomate.app/mobileapp';
          } else {
            setOpenModal(true);
          }
        }}
        container
        direction="row"
        spacing={2}
      >
        {items &&
          items.map((item: ProjectCard) => (
            <Grid key={item.title} item lg={3} md={6} sm={6} xs={12}>
              <Card style={{ width: '100%' }}>
                <CardMedia
                  onClick={() => console.log('card')}
                  sx={{ cursor: 'pointer' }}
                  component="img"
                  height="140"
                  image={item.image?.url}
                />
                <CardContent style={{ height: '50px' }}>
                  <Text>{item.title}</Text>
                </CardContent>

                <CardActions>
                  {item.tags.map((tag) => (
                    <Chip
                      key={tag.title}
                      size="small"
                      label={<Text>{tag.title}</Text>}
                      // href="#basic-chip"
                      clickable
                    />
                  ))}
                </CardActions>
              </Card>
            </Grid>
          ))}
      </Grid>

      <AppModal show={openModal} onClose={() => setOpenModal(false)} />
    </section>
  );
};

export default List;
